/**
 * InvestmentItemDetailRoute - Deep link route for investment items
 *
 * Route: /investment-lines/:id
 * Opens the InvestmentItemsListPage with the specified item's detail panel open.
 */

import { useParams, Navigate } from "react-router-dom";
import { InvestmentItemsListPage } from "./InvestmentItemsListPage";

export const InvestmentItemDetailRoute = () => {
  const { id } = useParams<{ id: string }>();

  // Parse ID from URL
  const itemId = id ? parseInt(id, 10) : null;

  // Redirect to list if invalid ID
  if (!itemId || isNaN(itemId)) {
    return <Navigate to="/renovation/investments" replace />;
  }

  // Render list page with initial item ID to open
  return <InvestmentItemsListPage initialOpenItemId={itemId} />;
};

export default InvestmentItemDetailRoute;
